import { useState } from "react"

import useTranslate from "@hooks/use_translate"
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material"

import ArticlesTab from "./sub_components/ArticlesTab"
import GapsTab from "./sub_components/GapsTab"
import SearchTab from "./sub_components/SearchTab"

const TABS = ["articles", "search", "gaps"] as const

/**
 * AI Hub → Help content. Qpien's own help articles the Operator answers how-to questions from:
 * imported here, indexed into their own RAG namespace, tested, and the questions it could not
 * answer listed so the next article is the one users actually asked for.
 */
export default function AiHelpPage() {
  const { translate } = useTranslate()
  const [tab, setTab] = useState<(typeof TABS)[number]>("articles")

  return (
    <Stack gap={2} p={3} maxWidth={1200}>
      <Stack gap={0.5}>
        <Typography variant="h5" fontWeight={600}>
          {translate("ai_help_title")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {translate("ai_help_subtitle")}
        </Typography>
      </Stack>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tab}
          onChange={(_event, value: (typeof TABS)[number]) => setTab(value)}
        >
          {TABS.map((value) => (
            <Tab
              key={value}
              value={value}
              label={translate(`ai_help_tab_${value}`)}
            />
          ))}
        </Tabs>
      </Box>
      {tab === "articles" && <ArticlesTab />}
      {tab === "search" && <SearchTab />}
      {tab === "gaps" && <GapsTab />}
    </Stack>
  )
}
